import { useAuthStore } from '@/stores/auth.store'

// COMO FUNCIONA AUTENTICACAO DO FRONTEND
// o GOV sempre retorna para o front/https://catadores-hmg.sinir.gov.br/authcallback
// entao o authcall back vai redirecionar para o nosso backend
// o nosso backend vai redirecionar para o frontend

// CATADORES FRONTEND -> GOV.BR - /authorize -> CATADORES AUTH

export default defineNuxtRouteMiddleware(async (to, from) => {
  // const runtimeConfig = useRuntimeConfig()
  // const api = runtimeConfig.public.api
  const api = window.location.origin + '/api'

  if (process.client) {
    const authStore = useAuthStore()

    //  PATHS SEM AUTENTICACAO
    // ------------------------
    if (to.path === '/login' || to.path === '/login/' || to.path.match(/ver\-organizacoes/g)) { // Login não precisa de autenticação, todo o resto vai precisar
      return
    }
    if (to.path === '/login-legado' || to.path === '/login-legado/') { // Login não precisa de autenticação, todo o resto vai precisar
      return
    }

    // GOV.BR redireciona para ca sempre, entorod os passos de autenticacao
    if (to.path === '/authcallback') {
      // console.log('authcallback.......')

      // se so retorna sem nada na url....acho que tem que fazer o login
      if (to.fullPath === '/authcallback') {
        return navigateTo('/home', { replace: true })
      }
      const urlcallback = api + '/auth' + to.fullPath

      // console.log('authcallback.......')
      // console.log(urlcallback)
      return navigateTo(urlcallback, { external: true, replace: true })
    }

    if (to.path === '/teste-redirect') {
      window.location.href = api + '/docs'
    }

    if (to.path === '/logout') {
      const logoutUrl = await authStore.logOutUrl()
      if (logoutUrl) {
        // o sso vai me retornar para a mesma pagina /logout
        return navigateTo(logoutUrl, { external: true, replace: true })
      }
      return navigateTo('/login')
    }

    //  Paths COM AUTENTICAÇÃO
    // ------------------------
    const wasAuthenticated = authStore.isAuthenticated
    const isAutenticante = await authStore.isOrTryAuthenticate()

    if (isAutenticante) {
      if (!wasAuthenticated) {
        if (authStore.isAdmin && from.path === '/login') {
          return navigateTo('/admin') // talvez mudar para o admin poder cadastrar cooperativas
        } else if (from.path === '/login') {
          return navigateTo('/home')
        }
      } else if (authStore.isAdmin && to.path === '/') {
        return navigateTo('/admin') // talvez mudar para o admin poder cadastrar cooperativas
      }
    } else {
      // console.log('isNotAuthenticated')
      return navigateTo('/login')
    }
  }
})
